<template>
  <div>
    <template v-if="isLoading">
      <div style="overflow-y: hidden">
        <Loader />
      </div>
    </template>
    <template v-else-if="advises.length == 0">
      {{ trans('subscription.no_active_advises') }}
    </template>
    <template v-else>
      <div
        v-if="selectedAdvise != null"
        class="selected_thread"
      >
        <AdviseThread
          :advise="selectedAdvise"
          :subscribable="selectedSubscibable"
          @close="deselect"
        />
      </div>
      <template
        v-for="advise in advises"
        v-else
      >
        <AdviseThreadHeader
          class="thread_header"
          :advise="advise"
          :subscribable="subscribables[advise.subscribable] || null"
          @threadSelected="selectAdvise(advise)"
        />
      </template>
    </template>
  </div>
</template>

<script>

import AdviseThread from '@/students/subscriptions/components/advise/AdviseThread'
import AdviseThreadHeader from '@/students/subscriptions/components/advise/AdviseThreadHeader'
import { mapState } from 'vuex'
import StudentCard from '@/students/components/StudentCard'
import Loader from '@/employees/components/Loader'

export default {
  name: 'AdviseDashboard',
  components: { AdviseThread, AdviseThreadHeader, StudentCard, Loader },
  props: {
    studentId: {
      require: true,
    },
  },
  data () {
    return {
      isLoading: true,
      selectedAdvise: null,
      selectedSubscibable: null,
    }
  },

  computed: {
    ...mapState({
      advises (state) {
        return state.advises.advises
      },
      subscribables (state) {
        return state.subscribables.subscribables
      },
    }),
  },

  mounted () {
    this.$store.dispatch('getAdvises', { studentId: this.studentId, queryParams: { include: ['messages', 'subscribable'] } })
      .then(() => {
        this.isLoading = false
      })
  },
  methods: {
    selectAdvise (advise) {
      this.selectedAdvise = advise
      this.selectedSubscibable = this.subscribables[advise.subscribable] || null
    },
    deselect () {
      this.selectedAdvise = null
      this.selectedSubscibable = null
    },
  },
}
</script>

<style scoped>
.thread_header {

  font-size:14px;
  margin-left:10px;
  padding: 20px;
}
.selected_thread{
  margin-left:10px;
  margin-right:10px;
}
</style>
